import { HotTableUndoRedoActionType } from './hotTableUndoRedoRichCellDataUtils';

const MILANOTE_HOT_ACTION_TYPES_WITHOUT_HYPER_FORMULA_CHANGE: readonly string[] = [
    HotTableUndoRedoActionType.MILANOTE_MOVE,
    HotTableUndoRedoActionType.MILANOTE_COLUMN_RESIZE,
    HotTableUndoRedoActionType.MILANOTE_META_CELL_DATA_CHANGE,
];

export const isMilanoteHotUndoRedoAction = (actionType: string) =>
    MILANOTE_HOT_ACTION_TYPES_WITHOUT_HYPER_FORMULA_CHANGE.includes(actionType);
